import React from "react";
import { motion } from "framer-motion";

export default function EventStaffingMoreFeatures() {
  const moreFeatures = [
    {
      title: "Print-ready Views",
      img: "/images/event-staffing/event-staffing-more-print.png",
      alt: "Print-ready Views and Sign In Sheets",
    },
    {
      title: "Repeat Party",
      img: "/images/event-staffing/event-staffing-more-repeat.png",
      alt: "Repeat Party and Duplicate Setup",
    },
    {
      title: "Post-event Reporting",
      img: "/images/event-staffing/event-staffing-more-report.png",
      alt: "Post-event Reporting and Feedback",
    },
    {
      title: "Audit & Log Management",
      img: "/images/event-staffing/event-staffing-more-audit.png",
      alt: "Audit and Log Management",
    },
    {
      title: "Role-based Access",
      img: "/images/event-staffing/event-staffing-more-role.png",
      alt: "Role-based Access and Permissions",
    },
    {
      title: "Track event",
      img: "/images/event-staffing/event-staffing-more-track.png",
      alt: "Track Event Live Operations",
    },
  ];

  return (
    <section className="es-more-features-wrapper">
      <div className="container-fluid horizontal-padding">
        {/* Section Title */}
        <div className="es-more-features-header mb-5">
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="es-section-title">More Features</h2>
          </motion.div>
        </div>

        {/* 6 Cards Grid (2 cols on md/lg, 1 on mobile) */}
        <div className="row g-4 es-more-features-grid">
          {moreFeatures.map((item, idx) => (
            <div key={idx} className="col-12 col-md-6">
              <motion.div
                className="es-more-card"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.6, delay: (idx % 2) * 0.15 }}
                whileHover={{ y: -5 }}
              >
                <div className="es-more-card-header">
                  <h3 className="es-more-card-title">{item.title}</h3>
                </div>
                <div className="es-more-card-mockup-frame">
                  <img
                    src={item.img}
                    alt={item.alt}
                    className="es-more-card-img"
                    loading="lazy"
                  />
                </div>
              </motion.div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
